import { ALTERAR_REGISTROS_POR_PAGINA_CIDADE } from '../types'

export default function alterarRegistrosPorPaginaCidades (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_CIDADE,
    payload: valor
  }
}
